import {
  WSAlert,
  WSCard,
  WSElement,
  WSFlexBox,
  WSList,
  WSPill,
  WSText
} from "@wingspanhq/fe-component-library";
import React from "react";

import { DataViewGrid } from "../../../../shared/components/DataView";
import { RequirementDefinitionTemplate } from "../../routes/RouteCreateRequirementByTemplate/types";
import { AlertBillableRequirement } from "../AlertBillableRequirement";
import { useEditRequirementDefinitionModal } from "../EditRequirementDefinitionModal/useEditRequirementDefinitionModal";

type RequirementDefinitionInfoCardProps = {
  editableRequirementDefinitionId?: string;
  template: RequirementDefinitionTemplate;
  name: string;
  description?: string;
  version: number;
};

export const RequirementInformationCard: React.FC<
  RequirementDefinitionInfoCardProps
> = ({
  editableRequirementDefinitionId,
  template,
  version,
  name,
  description
}) => {
  const typeName = template.name;
  const typeIcon = template.icon;
  const displayVersion = version ?? 1;

  const editRequirementDefinitionModal = useEditRequirementDefinitionModal();

  const onEdit = editableRequirementDefinitionId
    ? () => {
        editRequirementDefinitionModal.open({
          requirementDefinitionId: editableRequirementDefinitionId
        });
      }
    : undefined;

  return (
    <WSCard header="Requirement information">
      <WSList gap="XL">
        <DataViewGrid
          data={[
            {
              label:
                onEdit && template.isCustomName
                  ? {
                      action: { label: "Edit", onClick: onEdit },
                      text: "Name"
                    }
                  : "Name",
              value: name
            },
            {
              icon: typeIcon,
              label: "Type",
              value: typeName
            },
            {
              label: "Version",
              value: `v${displayVersion}`
            }
          ]}
          gridColumns={2}
        />
        <AlertBillableRequirement requirementName={name} template={template} />

        <WSElement colorBackground="gray50" p="M">
          <WSFlexBox
            alignItems="center"
            gap="M"
            justify="space-between"
            mb="S"
            wrap="nowrap"
          >
            <WSFlexBox.CenterY alignItems="center" gap="M" wrap="nowrap">
              <WSText.ParagraphSm weight="medium">
                Description
              </WSText.ParagraphSm>
              <WSPill icon="lock" text="Private" theme="neutral" />
            </WSFlexBox.CenterY>
            {onEdit ? (
              <WSText.ParagraphXs
                color="blue400"
                weight="medium"
                onClick={onEdit}
              >
                Edit
              </WSText.ParagraphXs>
            ) : null}
          </WSFlexBox>
          <WSText.ParagraphSm color="gray500">
            {description || "No description provided."}
          </WSText.ParagraphSm>
        </WSElement>
      </WSList>
    </WSCard>
  );
};
